var English = "Английский";
var French = "Французский";
var German = "Немецкий";
var Italian = "Итальянский";
var Japanese = "Японский";
var Korean = "Корейский";
var Portuguese = "Португальский";
var Russian = "Русский";
var Spanish = "Испанский";
var Bahasa = "Индонезийский";
var Thai = "Тайский";
var Vietnamese = "Вьетнамский";
var Turkish = "Турецкий";
var Arabic = "Арабский";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Китайский (упрощенный)",
	"Chinese-Traditional": "Китайский (традиционный)",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
